<template>
  <div class="singIn">
    <div class="logo">
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div
        v-if="isShowMyID"
        class="myIDLogin cursor">
        <!-- <span>Sign in with Disney MyID</span> -->
        <a :href="myIdUrl">Sign in with Disney MyID</a>
      </div>
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.singIn')}}</p>
        <p class="tvuDescribe">{{$t('lang.tvuTitle')}}</p>
      </div>
      <div class="singInForm">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm">
          <el-form-item prop="email">
            <div class="exchange emailArea ">
              <div class="tip">{{$t('lang.email')}}</div>
              <el-input
                class="input focusFade"
                tabindex='1'
                v-repeat-enter="{event:nextOpaertaion}"
                v-model="ruleForm.email"
                :placeholder="$t('lang.email')"
                @focus="focusInput"
                @blur="blurInput(1)"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="exchange pswArea">
              <div class="tip">{{$t('lang.password')}}</div>
              <el-input
                class="input focusFade"
                tabindex='2'
                autocomplete
                type="password"
                @focus="focusInput"
                v-repeat-enter="{event:nextOpaertaion}"
                @blur="blurInput(2)"
                @change="changesPsw"
                v-model="ruleForm.password"
                show-password
                id="password"
                :placeholder="$t('lang.password')"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="vcode">
            <div class="exchange vertical">
              <el-input
                v-model="ruleForm.vcode"
                tabindex='3'
                class="vcodeInput"
                maxlength="4"
                :placeholder="$t('lang.vcodePlaceholder')"
                v-repeat-enter="{event:nextOpaertaion}"></el-input>
              <div class="vcode">
                <img
                  class="cursor"
                  :src="'data:image/jpeg;base64,'+imgUrl"
                  alt=""
                  @click='getVcode'>
              </div>
              <!-- <div class="warning">
								<i class="el-icon-warning-outline"></i>
								<span class="warningTip">Incorrect verification code</span>
							</div> -->
            </div>
          </el-form-item>
          <el-checkbox
            class="isChecked"
            size="medium"
            v-model="checked">{{$t('lang.remenberMe')}}</el-checkbox>
        </el-form>
        <div class="forgetPsw">
          <span
            class="cursor"
            @click="routerPush('/forget')">{{$t('lang.forget')}}</span>
        </div>
        <div class="confirmArea">
          <span
            class="cursor createAccount"
            @click="createAccount">{{$t('lang.createAccount')}}</span>
          <el-button
            v-repeat-click="{event:nextOpaertaion}"
            class="confirmBtn cursor"
            :disabled='isDisabeBtn'
            :loading="isLoading">{{$t('lang.next')}}</el-button>
        </div>
        <el-divider
          v-if="isShowThirdParty"
          class="ssoDivder"
          content-position="center">{{isCn ? $t('lang.platCn') : $t('lang.plat')}}</el-divider>
        <div
          class="otherLogin"
          v-if="isShowThirdParty">
          <!-- <i class="iconfont iconfacebook cursor" @click="fbLogin"></i> -->
          <!-- <img class='cursor' :src="thirdPartyImg[item]" alt=""  > -->
          <!-- <img class='cursor googleBtn' :src="thirdPartyImg['Google']" alt="" @click="ggLogin" > -->
          <!-- <div class="img googleBtn" :style="'background-image:'+thirdPartyImg['Google']+';'"></div> -->
          <el-image
            style="width: 48px;"
            :id="item.toLowerCase()+'Btn'"
            :class="['cursor',item.toLowerCase()+'Btn']"
            :src="thirdPartyImg[item]"
            @click="thirdLogin(item)"
            v-for="(item,index) in socialLogin"
            :key="index"></el-image>
          <!-- <i class="iconfont iconfontapple">&#xe66c;</i>
					<i class="iconfont icongoogle"></i> -->
        </div>
        <div
          class="sso"
          v-if="isShowThirdParty && !isCn">
          <span
            class='cursor'
            @click="routerPush('/signInsso')">{{$t('lang.ssoSign')}}</span>
        </div>
      </div>
    </div>
    <Remainder
      :dialogVisible="dialogVisible"
      :session="wsSession"
      @otherLogin="otherLogin"></Remainder>
  </div>
</template>

<script>
// @ is an alias to /src
import Remainder from '@/components/Remainder.vue'
import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import { getUrlParam } from '@/assets/js/utils'
import Bus from '@/assets/js/vueBus'
import { PublicClientApplication } from '@azure/msal-browser'
const sha512 = require('js-sha512')
export default {
  name: 'Home',
  components: {
    Remainder
  },
  data () {
    return {
      isCn: false,
      ruleForm: {
        email: '',
        password: '',
        vcode: ''
      },
      email: '',
      password: '',
      vcode: '',
      isShowStrength: false,
      isDisabeBtn: true,
      emailErrorTip: '',
      verifyCode: {},
      phone: '',
      imgUrl: '',
      checked: false,
      isLoading: false,
      domainName: '',
      isShowThirdParty: true,
      thirdPartyImg: {
        FaceBook: require('@/assets/img/facebook.png'),
        Google: require('@/assets/img/google.png'),
        Apple: require('@/assets/img/apple.png'),
        WeChat: require('@/assets/img/facebook.png'),
        AliPay: require('@/assets/img/facebook.png'),
        Auth0: require('@/assets/img/Auth0.png'),
        Microsoft: require('@/assets/img/microsoft.png'),
        Wechat: require('@/assets/img/wxOtherLogin.png')
      },
      loadingObj: null,
      dialogVisible: false,
      wsSession: ''
    }
  },
  mounted () {
    if (window.location.host.includes('cn')) {
      this.isCn = true
    }
    this.$store.commit('changeShowConfig', false)
    this.rules.email[0].message = this.$t('lang.emailTip')
    this.rules.password[0].message = this.$t('lang.passwordTip')
    this.rules.vcode[0].message = this.$t('lang.vcodeTip')
    // 获取图片验证码isSuccess&&!isShowMyID&&!isConfig
    if (!this.$store.state.isSuccess && this.$route.path == '/signIn') {
      this.getVcode()
    }
    // 获取记住密码相关信息
    this.getCookie()
    // let href
    // if(this.$store.state.href){
    // 	// href = this.$store.state.href;
    // }else{

    const href = window.location.href
    this.$store.state.href = href
    // }
    if (!href.includes('type=') && href.includes('url=')) {
      const encodeHref = decodeURIComponent(href)

      this.$store.state.location = encodeHref.substring(encodeHref.indexOf('?') + 1).split('#')[0].split('url=')[1]
    }
    const u = navigator.userAgent
    // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端

    const isiOS = Boolean(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) // ios终端

    if (isiOS && this.socialLogin.indexOf('Apple') == -1) { // ios机型
      this.isShowThirdParty = false
    }
    if (this.isPc === false) {
      this.isShowThirdParty = false
    }
    // this.ggLoginInit();
    Bus.$emit('loadGooleBtn')
    Bus.$emit('showGoogleTipEvent')
  },
  watch: {
    ruleForm: {
      handler (val) {
        if (val.email && val.password && val.vcode) {
          this.isDisabeBtn = false
        } else {
          this.isDisabeBtn = true
        }
      },
      deep: true
    }
  },
  computed: {
    rules () {
      return {
        email: [
          { required: true, message: this.$t('lang.emailTip'), trigger: 'blur' }
          // { pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ , message: 'Enter correct email format', trigger: 'blur'}
        ],
        password: [{ required: true, message: this.$t('lang.passwordTip'), trigger: 'blur' }],
        vcode: [{ required: true, message: this.$t('lang.vcodeTip'), trigger: 'blur' }]
      }
    },
    myIdUrl () {
      if (this.$store.state.myIdUrl.indexOf('http') > -1) {
        return this.$store.state.myIdUrl
      }
      return 'https://' + this.$store.state.myIdUrl
    },
    ...mapState({
      httpsFlag: 'httpsFlag',
      tagKeys: 'tagKeyList',
      isShowMyID: 'isShowMyID',
      key: 'key',
      isPc: 'isPc',
      socialLogin: function (state) { // 用普通函数this指向vue实例,要注意
        return state.socialLogin
      },
      searchRegisterUrl: 'searchRegisterUrl',
      googleClientId: 'googleClientId',
      googleRedirectUrl: 'googleRedirectUrl',
      appleClientId: 'appleClientId',
      appleRedirectUrl: 'appleRedirectUrl'
    })
  },
  methods: {
    otherLogin (data) {
      if (data.agree == 2) {
        return
      }
      this.remenberPsw()
      const href = this.$store.state.href || window.location.href
      const flag = href.includes('type=')

      localStorage.setItem('email', data.email)
      localStorage.setItem('firstName', data.firstName)
      localStorage.setItem('userName', data.userName)
      localStorage.setItem('session', data.session)
      localStorage.setItem('userservice', data.userservice)
      window.userservice = data.userservice
      if (this.domainName) {
        // window.document.cookie = `session=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
        // window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
        if (data.tagList && data.tagList.length > 0 && this.$store.state.saveTagCookie) {
          data.tagList.forEach(itm => {
            window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
          })
        }
        // data.tvutag?window.document.cookie = "tvutag=" +data.tvutag+ ";path=/;domain=" + this.domainName + ";":"";
      }
      if (flag) {
        // 移动调用方法
        // window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
        if (data.tagList && data.tagList.length > 0 && this.$store.state.saveTagCookie) {
          data.tagList.forEach(itm => {
            window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
          })
        }
        // data.tvutag?window.document.cookie = "tvutag=" +data.tvutag+ ";path=/;domain=" + this.domainName + ";":"";
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端

        if (isAndroid) { // 安卓机型
          // getUserInfo(data.userId, data.session);
          Android.getUserInfo(JSON.stringify({
            userId: data.userId,
            session: data.session,
            firstName: data.firstName,
            email: data.email
          }))
        } else { // ios机型
          window.webkit.messageHandlers.getUserInfo.postMessage(JSON.stringify({
            userId: data.userId,
            session: data.session,
            firstName: data.firstName,
            email: data.email
          }))
          // 通知gridlink登录成功
          window.webkit.messageHandlers.hideNavIfLogin.postMessage(JSON.stringify({}))
        }
      } else {
        // web跳转
        if (data.loginWelcome == '1') {
          this.$store.state.isSuccess = true
          this.$store.state.validSid = true
          this.$router.push('/welcome')
        } else {
          window.top.location.href = data.redirectUrl
        }
      }
    },
    wxLogin () {
      this.$router.push('/qrcode')
    },
    thirdLogin (item) {
      this.loadingObj = Loading.service({
        target: document.querySelector('.' + item.toLowerCase() + 'Btn'),
        fullscreen: false,
        body: false,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'customImage'
      })
      switch (item) {
        case 'FaceBook':
          this.fbLogin()
          break
        case 'Auth0':
          this.auth0Login()
          break
        case 'Google':
          this.ggLogin()
          break
        case 'Microsoft':
          this.microsoftLogin()
          break
        case 'Wechat':
          this.wxLogin()
          break
        case 'Apple':
          this.appleLogin()
          break
        default:
          break
      }
    },
    appleLogin () {
      let stateParam = ''
      if (getUrlParam('serviceName')) {
        const serverName = getUrlParam('serviceName')
        const url = getUrlParam('url')
        const stateValue = JSON.stringify({ serverName: serverName, url: url })
        stateParam = encodeURIComponent(btoa(stateValue)) // 编码以确保URL安全
      }
      if (getUrlParam('type')) {
        const type = getUrlParam('type')
        const pid = getUrlParam('pid')
        const stateValue = JSON.stringify({ type: type, pid: pid })
        stateParam = encodeURIComponent(btoa(stateValue)) // 编码以确保URL安全
      }
      // 初始化Apple ID认证
      AppleID.auth.init({
        clientId: this.appleClientId || 'com.tvunetworks.TVUCCMobileServicesID', // 从 Services ID 中获取
        scope: 'email name',
        redirectURI: this.appleRedirectUrl || 'https://cc-ms-dev.tvunetworks.com/userGroup/user-group/login/apple', // 与苹果开发者后台设置的一致
        usePopup: false, // 使用弹出窗口或重定向
        state: stateParam
      })

      setTimeout(() => {
        this.loadingObj.close()
      }, 2000)

      // 进行登录
      AppleID.auth.signIn().then(response => {
        window.console.log('Apple login successful:', response)
        // response 包含 ID Token 等信息
        // 将 ID Token 发给后端进行验证和处理
        // const idToken = response.authorization.id_token
      }).catch(error => {
        window.console.error('Apple login failed:', error)
      })
    },
    // 微软登录
    microsoftLogin () {
      const that = this
      const id = localStorage.getItem('microsoftClientId')
      const config = {
        auth: {
          clientId: id // defaults to application start page
        }
      }

      const loginRequest = {
        scopes: ['User.ReadWrite']
      }

      const myMsal = new PublicClientApplication(config)

      myMsal.loginPopup(loginRequest)
        .then(function (loginResponse) {
          window.console.log(loginResponse)
          that.fetchMicrosoftInfo(loginResponse.accessToken, loginResponse.account.username)
        }).catch(function () {
        // login failure
          that.loadingObj.close()
        })
    },
    fetchMicrosoftInfo (token, name) {
      this.axios.post('/userGroup/user-group/login/microsoft',
        {
          email: name,
          accessToken: token,
          serverName: getUrlParam('serviceName'),
          redirectUrl: getUrlParam('url')
        }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.afterThirdParty(res)
        } else if (res.data.errorCode == '80943007') {
          // this.$message({
          //   message:
          //     'TVU administrator and support accounts must use \'Login with Google\' for access.',
          //   type: 'error',
          //   duration: 3000
          // })
          Bus.$emit('googleChange', true)
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
        this.loadingObj.close()
      }).catch(() => {
        this.loadingObj.close()
      })
    },
    auth0Login () {
      this.axios.get('/userGroup/user-group/login/auth0/redirect', {}).then((res) => {
        this.loadingObj.close()
        if (res.data.errorCode == '0x0') {
          location.href = res.data.result
        }
      }).catch(() => {
        this.loadingObj.close()
      })
    },
    // ggLoginInit(){
    // 	auth2.attachClickHandler(document.getElementById('googleBtn'), {},
    // 		function(googleUser) {
    // 			this.loadingObj.close();
    // 		},
    // 		function(error) {
    // 		);
    // 	});
    // },
    ggLogin () {
      const client_id = this.googleClientId
      const redirect_uri = this.googleRedirectUrl
      // const redirect_uri = 'https://cc-ms-dev.tvunetworks.com/userGroup/user-group/login/v2/google' // 本地调试
      const scope = 'email profile'
      // const response_type = 'token'
      const response_type = 'code'
      let stateParam = ''
      if (getUrlParam('serviceName')) {
        const serverName = getUrlParam('serviceName')
        const url = getUrlParam('url')
        const stateValue = JSON.stringify({ serverName: serverName, url: url })
        stateParam = encodeURIComponent(btoa(stateValue)) // 编码以确保URL安全
      }
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${client_id}&redirect_uri=${encodeURIComponent(redirect_uri)}&scope=${encodeURIComponent(scope)}&response_type=${response_type}&prompt=select_account&state=${stateParam}`

      // 重定向到Google登录页面
      window.top.location.href = authUrl

      setTimeout(() => {
        this.loadingObj.close()
      }, 2000)
      // const that = this
      // if (!gapi && !gapi.auth2) {
      //   that.$message.error(that.$t('lang.googleErrorTips'))
      //   that.loadingObj.close()
      //   return
      // }
      // if (gapi.auth2.getAuthInstance().isSignedIn.get()) {
      //   gapi.auth2.getAuthInstance().signOut().then(function () {
      //     that.ggLogin()
      //   })
      // } else {
      //   gapi.auth2.getAuthInstance().signIn({
      //     scope: 'profile email'
      //   }).then(function (resp) {
      //     // that.loadingObj.close();
      //     that.fetchGoogleInfo(resp.getBasicProfile(), resp.getAuthResponse(true))
      //   }).catch(({ error }) => {
      //     that.loadingObj.close()
      //     if (error == 'popup_closed_by_user') {
      //       // 手动关闭登录框
      //     } else if (error == 'access_denied') {
      //       // 取消授权异常
      //     }
      //   })
      // }
    },
    fetchGoogleInfo (userInfo, authInfo) {
      this.axios.post('/userGroup/user-group/login/google',
        {
          email: userInfo.getEmail(),
          accessToken: authInfo.id_token,
          serverName: getUrlParam('serviceName'),
          redirectUrl: getUrlParam('url')
        }
      ).then((res) => {
        this.afterThirdParty(res)
      }).catch(() => {
        this.loadingObj.close()
      })
    },
    fbLogin () {
      const that = this

      FB.getLoginStatus(function (response) {
        that.statusChangeCallback(response)
      })
    },
    statusChangeCallback (loginResponse) { // Called with the results from FB.getLoginStatus().
      const that = this

      if (loginResponse.status === 'connected') { // Logged into your webpage and Facebook.
        FB.api('/me/permissions', function (permissionResponse) {
          const declined = []

          for (let i = 0; i < permissionResponse.data.length; i++) {
            if (permissionResponse.data[i].status == 'declined' || permissionResponse.data[i].status == 'expired') {
              declined.push(permissionResponse.data[i].permission)
            }
          }
          if (declined.indexOf('email') > -1) {
            // const num = 0

            FB.logout(function () {
              // num++;
              // if(num == 1){
              // 	that.$alert('You have cancelled the necessary authorization for Facebook login, please log in again and authorize', 'Warning', {
              // 		confirmButtonText: 'Confirm',
              // 		callback: action => {}
              // 	});
              // }
              that.loadingObj.close()
            })
          } else {
            that.fetchFBInfo(loginResponse)
          }
        })
        // this.fetchFBInfo(response);
      } else { // Not logged into your webpage or we are unable to tell.
        FB.login(function (loginResponse) {
          if (loginResponse.status === 'connected') {
            // Logged into your webpage and Facebook.
            FB.api('/me/permissions', function (permissionResponse) {
              const declined = []

              for (let i = 0; i < permissionResponse.data.length; i++) {
                if (permissionResponse.data[i].status == 'declined') {
                  declined.push(permissionResponse.data[i].permission)
                }
              }
              if (declined.indexOf('email') > -1) {
                // const num = 0

                FB.logout(function () {
                  // num++;
                  // if(num == 1){
                  // 	that.$alert('You have cancelled the necessary authorization for Facebook login, please log in again and authorize', 'Warning', {
                  // 		confirmButtonText: 'Confirm',
                  // 		callback: action => {}
                  // 	});
                  // }
                  that.loadingObj.close()
                })
              } else {
                that.fetchFBInfo(loginResponse)
              }
            })
          } else {
            // The person is not logged into your webpage or we are unable to tell.
            that.loadingObj.close()
          }
        }, {
          scope: 'email',
          return_scopes: true,
          auth_type: 'rerequest'
        })
      }
    },
    afterThirdParty (res) {
      this.loadingObj.close()
      if (res.data.errorCode == '0x0') {
        const data = res.data.result
        // 登录成功存储sid

        // if (this.domainName) {
        //   window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
        // }
        localStorage.setItem('email', data.email)
        localStorage.setItem('firstName', data.firstName)
        localStorage.setItem('userName', data.userName)
        localStorage.setItem('session', data.session)
        localStorage.setItem('userservice', data.userservice)
        window.userservice = data.userservice
        if (data.loginWelcome == '1') {
          this.$store.state.validSid = true
          this.$store.state.isSuccess = true
          this.$router.push('/welcome')
        } else {
          window.top.location.href = data.redirectUrl
        }
      }
    },
    fetchFBInfo (authResponse) { // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
      const that = this

      FB.api('/me?fields=name,email', function (response) {
        that.axios.post('/userGroup/user-group/login/facebook',
          {
            email: response.email,
            id: response.id,
            accessToken: authResponse.authResponse.accessToken,
            serverName: getUrlParam('serviceName'),
            redirectUrl: getUrlParam('url')
          }
        ).then((res) => {
          if (res.data.errorCode == '0x0') {
            that.afterThirdParty(res)
          } else if (res.data.errorCode == '80943007') {
            // this.$message({
            //   message:
            //     'TVU administrator and support accounts must use \'Login with Google\' for access.',
            //   type: 'error',
            //   duration: 3000
            // })
            Bus.$emit('googleChange', true)
          } else {
            this.$message({
              message: res.data.errorInfo,
              type: 'error',
              duration: 3000
            })
          }
          // that.loadingObj.close();
          // if(res.data.errorCode == '0x0'){
          // 	let data = res.data.result;
          // 	// 登录成功存储sid
          // 	if(that.domainName){
          // 		window.document.cookie = `SID=${data.session};path=/;domain=${that.domainName};${that.httpsFlag?'secure':''}`;
          // 	}
          // 	localStorage.setItem('email',data.email);
          // 	localStorage.setItem('firstName',data.firstName);
          // 	localStorage.setItem('userName',data.userName);
          // 	localStorage.setItem('session',data.session);
          // 	localStorage.setItem('userservice',data.userservice);
          // 	window.userservice = data.userservice;
          // 	if(!data.hasOwnProperty('redirectUrl')){
          // 		that.$store.state.isSuccess = true;
          // 		that.$router.push('/welcome');
          // 	}else{
          // 		window.top.location.href = data.redirectUrl;
          // 	}
          // }
          this.loadingObj.close()
        }).catch(() => {
          that.loadingObj.close()
        })
      })
      // FB.api('/me/permissions', function(response) {
      // });
    },
    remenberPsw () {
      // 判断复选框是否被勾选 勾选则调用配置cookie方法
      if (this.checked == true) {
        // 传入账号名，密码，和保存天数3个参数
        this.setCookie(this.ruleForm.email, this.ruleForm.password, 30)
      } else {
        // 清空Cookie
        this.clearCookie()
      }
    },
    // 设置cookie
    setCookie (c_name, c_pwd, exdays) {
      const exdate = new Date() // 获取时间

      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'userLoginName' + '=' + window.btoa(unescape(encodeURIComponent(c_name))) + ';path=/;domain=' + this.domainName + ';expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + window.btoa(unescape(encodeURIComponent(c_pwd))) + ';path=/;domain=' + this.domainName + ';expires=' + exdate.toGMTString()
      window.document.cookie = 'isChecked' + '=' + this.checked + ';path=/;domain=' + this.domainName + ';expires=' + exdate.toGMTString()
    },
    // 读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        const arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下

        for (let i = 0; i < arr.length; i++) {
          const arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值

          if (arr2[0] == 'userLoginName') {
            this.ruleForm.email = decodeURIComponent(escape(window.atob(arr2[1]))) // 保存到保存数据的地方
          } else if (arr2[0] == 'userPwd') {
            this.ruleForm.password = decodeURIComponent(escape(window.atob(arr2[1])))
          } else if (arr2[0] == 'isChecked') {
            this.checked = arr2[1] == 'true'
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    },
    getVcode () {
      this.axios.get(
        '/userGroup/user-group/login/getVCode',
        {
          width: 80,
          height: 40
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        if (res.data.errorCode == '0x0') {
          this.imgUrl = res.data.result.vCode
          this.$store.state.key = res.data.result.key
          // let host = window.location.host;
          // if(host.indexOf('.'+res.data.result.domain+'.')>-1){
          // 	let lastDomain = host.split('.').slice(-1);
          // 	this.domainName = res.data.result.domain + '.' + host.split('.').slice(-1);
          // }else{
          // 	this.domainName = res.data.result.domain;
          // }
          // url上截取domain
          // let localUrl = window.location.href
          // let str1 = localUrl.split(".")[1]
          // let str2 = localUrl.split(".")[2].split("/")[0]
          const localUrl = window.location.hostname
          const str1 = localUrl.split('.')[1]
          const str2 = localUrl.split('.')[2]

          this.domainName = `.${str1}.${str2}`

          const exp = new Date()

          exp.setTime(exp.getTime() - 1)
          window.document.cookie = `SID=;path=/;domain=${this.domainName};expires=${exp.toGMTString()};${this.httpsFlag ? 'Secure=true;' : ''}`
          window.document.cookie = `SID=;path=/;domain=${this.domainName};expires=${exp.toGMTString()};`
          // window.document.cookie = `tvutag=;path=/;domain=${this.domainName};expires=${exp.toGMTString()}`;
          this.tagKeys.forEach((item) => {
            window.document.cookie = `${item}=;path=/;domain=${this.domainName};expires=${exp.toGMTString()}`
          })
        } else {
          this.$message({
            message: this.$t('lang.error80943601'),
            type: 'error',
            duration: 3000
          })
        }
      }).catch((err) => {
        this.$message({
          message: err,
          type: 'error',
          duration: 3000
        })
      })
    },
    // 解析地址参数并返回obj参数
    getParams (paramStr) {
      const paramsObj = {}

      if (paramStr.includes('&')) {
        paramStr.split('&').forEach(item => {
          const str = item.split('=')

          paramsObj[str[0]] = str[1]
        })
      } else {
        const str = paramStr.split('=')

        paramsObj[str[0]] = str[1]
      }
      return paramsObj
    },
    // getUrlParam(name){
    // 	var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    // 	var r = window.location.search.substr(1).match(reg)||window.location.hash.substr(window.location.hash.indexOf('?')+1).match(reg);
    // 	if (r!=null) return unescape(r[2]); return null;
    // },
    nextOpaertaion (tag) {
      // ga('send', 'event', 'newUserService-singIn-login', 'click')
      gtag('event', 'newUserService-singIn-login')
      const that = this

      if (this.isLoading) {
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        // 移动端url
        const href = this.$store.state.href || window.location.href
        // let href = 'http://211.160.178.10:20088/newuserservice/#/signIn?type=tvuhitme&peerId=1234&deviceName=aaa&vertion=111&deviceType=r';
        const condition = {
          email: that.ruleForm.email,
          pwd: sha512(that.ruleForm.password).toUpperCase(),
          imgCode: that.ruleForm.vcode,
          key: this.key
        }

        let flag = false// false web;true anywhere

        if (href.includes('type=')) {
          // 移动端传参
          flag = true
          let val = []

          val = decodeURIComponent(href).split('?')
          const paramsObj = this.getParams(val[1])

          Object.assign(condition, paramsObj)
        } else {
          let val

          flag = false
          // web 传参https://newuserservice.tvunetworks.com/newuserservice/?url=https://cc.tvunetworks.com/tvucc&serviceName=Command%20Center#/signIn
          let url

          let envFlag = true

          if (href.indexOf('?') > -1) {
            if (process.env.NODE_ENV === 'production' && !href.includes('newuserservice')) {
              envFlag = false
            }
            if (envFlag) {
              const encodeHref = decodeURIComponent(href)

              val = encodeHref.substring(encodeHref.indexOf('?') + 1)
              if (val.includes('serviceName')) {
                val = val.split('url=')[1].split('#')[0].split('&serviceName=')
                url = val[0]
                condition.serverName = getUrlParam('serviceName')
                condition.url = url
              }
            }
            that.$store.state.location = url// decodeURIComponent(href).split('?')[1].split('#')[0].split('url=')[1]
          } else {
            condition.loginType = 1
          }
        }
        this.isLoading = true
        // 请求并跳转
        if (tag && tag == 'loginFlag') {
          condition.loginFlag = 1
        }
        this.axios.post(
          '/userGroup/user-group/login/signIn',
          condition
        ).then((res) => {
          this.isLoading = false
          // res.data.errorCode = '80943006';
          if (res.data.errorCode == '0x0') {
            // let session = res.data.result;
            const data = res.data.result

            // 登录成功存储sid
            this.remenberPsw()
            localStorage.setItem('email', that.ruleForm.email)
            localStorage.setItem('firstName', data.firstName)
            localStorage.setItem('userName', data.userName)
            localStorage.setItem('session', data.session)
            localStorage.setItem('userservice', data.userservice)
            window.userservice = data.userservice
            if (this.domainName) {
              // window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
              if (data.tagList && data.tagList.length > 0 && this.$store.state.saveTagCookie) {
                data.tagList.forEach(itm => {
                  window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
                })
              }
              // data.tvutag?window.document.cookie = "tvutag=" +data.tvutag+ ";path=/;domain=" + this.domainName + ";":"";
            }
            // 此时设置sid有效
            this.$store.state.validSid = true
            if (flag) {
              // 移动调用方法
              // window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
              if (data.tagList && data.tagList.length > 0 && this.$store.state.saveTagCookie) {
                data.tagList.forEach(itm => {
                  window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
                })
              }
              // data.tvutag?window.document.cookie = "tvutag=" +data.tvutag+ ";path=/;domain=" + this.domainName + ";":"";
              const u = navigator.userAgent
              const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端

              if (isAndroid) { // 安卓机型
                // getUserInfo(data.userId, data.session);
                Android.getUserInfo(JSON.stringify({
                  userId: data.userId,
                  session: data.session,
                  firstName: data.firstName,
                  email: data.email
                }))
              } else { // ios机型
                window.webkit.messageHandlers.getUserInfo.postMessage(JSON.stringify({
                  userId: data.userId,
                  session: data.session,
                  firstName: data.firstName,
                  email: data.email
                }))
                // 通知gridlink登录成功
                window.webkit.messageHandlers.hideNavIfLogin.postMessage(JSON.stringify({}))
              }
            } else {
              // web跳转
              if (data.loginWelcome == '1') {
                this.$store.state.isSuccess = true
                this.$router.push('/welcome')
              } else {
                window.top.location.href = data.redirectUrl
              }
            }
          } else if (res.data.errorCode == '80943701') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943701'),
              type: 'error',
              duration: 5000,
              offset: 80
            })
          } else if (res.data.errorCode == '80943001') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943002'),
              type: 'error',
              duration: 5000
            })
          } else if (res.data.errorCode == '80943002') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943002'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943003') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943003'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943004') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943004'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943702') { // 验证码错误
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943702'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943006') {
            // 建立websocket连接
            this.wsSession = res.data.result
            this.dialogVisible = true
          } else if (res.data.errorCode == '80943007') {
            this.getVcode()
            Bus.$emit('googleChange', true)
          } else if (res.data.errorCode == '80943010') {
            this.getVcode()
            let info = this.$i18n.locale == 'zh' ? '，还有' : '. '
            this.$message({
              message: this.$t('lang.error80943002') + info + res.data.errorInfo + this.$t('lang.error80943010'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943009') {
            this.getVcode()
            this.$message({
              message: this.$t('lang.error80943009'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943011') {
            this.getVcode()
            Bus.$emit('ssoChange', true)
          } else {
            this.getVcode()
            this.$message({
              message: res.data.errorInfo,
              type: 'error',
              duration: 3000
            })
          }
          // else if(res.data.errorCode == '80943006') {
          // 	let	h = this.$createElement
          // 	let _this = this
          // 	let newDatas = [h('p', null, this.$t('lang.logOutTips')), h('p', null, this.$t('lang.logOutTipsOther'))]
          // 	this.$confirm(h('div', null, newDatas), this.$t('lang.logOutElse'), {
          // 		confirmButtonText: this.$t('lang.yesLog'),
          // 		cancelButtonText: this.$t('lang.cancelLog'),
          // 		closeOnClickModal: false,
          // 		customClass: 'logTips',
          // 		iconClass: ''
          // 	}).then(() => {
          // 		_this.nextOpaertaion('loginFlag')
          // 	}).catch(() => {
          // 		this.getVcode();
          // 	})
          // }
        }).catch(() => {
          this.isDisabeBtn = false
        })
      })
    },
    focusInput (event) {
      $(event.target).parent().prev('.tip').css({
        display: 'inline-block'
      })
    },
    blurInput (num) {
      // num ,1代表email失去焦点，2代表password失去焦点
      // $(event.target).parent().prev(".tip").css('color','rgba(153,153,153,1)');
      if (num == 1) { //
        this.email ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      } else {
        this.password ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      }
    },
    changesPsw () {
      // 解决ios app自动填充密码的时候，不能点击下一步, (实际获取不到密码的问题)
      const value = $('#password').val()
      if (value != '' && this.ruleForm.password != value) {
        this.ruleForm.password = value
      }
    },
    // 路由跳转
    routerPush (path) {
      this.$router.push(path).catch(err => {
        // 可能sign路由没加载完，就点击跳转导致导航错误
        window.console.info(1081, 'router error', err)
      })
      // ga('send', 'event', 'newUserService-singIn-leave', 'click')
      gtag('event', 'newUserService-singIn-leave')
      this.$router.push(path)
    },
    createAccount () {
      const str = getUrlParam('serviceName')

      if (str == 'TVU Search' || str == 'TVU Search Stage') {
        window.location.href = this.searchRegisterUrl
      } else {
        this.routerPush('/create')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('setIsSuccess', false)
    })
  }
}
</script>
